import React, { useState } from "react";
import ProjectInitDialog from "./ProjectInitDialog";
import { useParams } from "../util";
import { useEffect } from "react";
import axios from "axios";
import { ProjectTmp } from "../models/projectsTmp";
import AwsCredsDialog, { AwsCreds } from "./AwsCredsDialog";
import { BackendURL } from "../globals";
import { authToken } from "../components/Authentication";

export const initPath = "/init/:uuid";
const apiRoot = `${BackendURL}/api`;

export default function InitPage() {
  type InitStep = "new_project" | "aws_creds" | "done";
  const { uuid } = useParams(initPath);
  const [project, setProject] = useState({} as ProjectTmp);
  const [step, setStep] = useState("new_project" as InitStep);
  const [isProjectNameDuplicate, setIsProjectNameDuplicate] = useState(false);

  axios.defaults.headers.common["Authorization"] = `Bearer ${authToken}`;

  async function onProjectInit(project: ProjectTmp) {
    axios
      .post(`${apiRoot}/tmpProjects/${uuid}/commit/`, { ...project })
      .then((response) => {
        setProject(response.data);
        setStep("aws_creds");
      })
      .catch((error) => {
        const message = error.response?.data?.name;
        if (
          message &&
          message.includes("project with this name already exists.")
        ) {
          setIsProjectNameDuplicate(true);
        }
      });
  }

  async function onAwsCredsEntered(creds: AwsCreds) {
    setStep("done");
    const response = await axios.post(
      `${apiRoot}/projects/${project.name}/init_deploy/`,
      {
        aws_user_access_key: creds.key,
        aws_user_secret_key: creds.secret,
      }
    );
    const deployment_job_id = response.data.id;
    window.location.href = `#/projects/${project.name}/deployments/${deployment_job_id}`;
  }

  useEffect(() => {
    async function doUseEffect() {
      const response = await axios.get(`${apiRoot}/tmpProjects/${uuid}/`);
      const projectData = response.data as ProjectTmp;
      setProject(projectData);
    }
    doUseEffect();
  }, [uuid]);

  return (
    <>
      <ProjectInitDialog
        open={step === "new_project"}
        project={project}
        onSubmit={onProjectInit}
        setProject={setProject}
        isNameDuplicate={isProjectNameDuplicate}
      />
      <AwsCredsDialog
        open={step === "aws_creds"}
        onSubmit={onAwsCredsEntered}
      />
    </>
  );
}
